// extracted by mini-css-extract-plugin
export default {"title":"P2nDy2","description":"aPAPZB"};